import { dbs } from "@/firebase/firestore"
import { User, UserOptions } from "./shared/user"
import { fieryBindings, fieryMapMutations } from "fiery-vuex"

const usersDB: any = dbs.users

export default {
	namespaced: true,
	state: {
		users: {},
		users_a: []
	},
	mutations: {
		SET_USERS(state, getUsers) {
			let users = getUsers()
			state.users = users
			state.users_a = Object.values(users)
		},
	},
	getters: {},
	actions: {
		...fieryBindings(
			{
				fetchUsers( { state, rootState, dispatch, getters, rootGetters }, payload, $fiery ) {
					const options = {
						extends: UserOptions
					}
					return $fiery(usersDB, options, "SET_USERS")
				},
			},
			{ commitInitial: false }
		),
		async save({ state, dispatch, commit, rootState, rootGetters }, payload) {
			return state.current.update(rootGetters.currentUserID)
		},
		async remove({ state, commit }, customerID) {
			return state.users[customerID]
				? state.users[customerID].remove()
				: false
		}
	}
}
